module.exports = {

    formatStrikethrough: function formatStrikethrough(title) {
        if (!title) return ""
        const doubleStrike = title.replace(/-\[\[([^\]]+)\]\]/g, "<span class=\"doublestrike\">$1</span>");
        const bothStrikes = doubleStrike.replace(/-\[([^\]]+)\]/g, "<span class=\"singlestrike\">$1</span>");
        return bothStrikes;
    }
}